<div
	class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini u-bg-primary c-portlet_box_specs pos-relative mainDiv"
	style="height: 412px;"
>
	<app-loader [showLoader]="showLoad"></app-loader>

	<div class="c-portlet o-block u-width-100p _u-width-100p stats-container">
		<div class="o-stack__cell primary-color">
			<h5 class="title primary-color">
				{{ sectiontitle }}
				<a
					href="javascript:void(0)"
					class="download_icon"
					*ngIf="downloadConfiguration?.enableDownload && hasData"
					(click)="downloadCSV()"
					target="_blank"
					><img src="../../../../../assets/images/Download_Icon.svg"
				/></a>
			</h5>
		</div>
	</div>

	<div class="analytics-portlet-content" [ngClass]="{ 'no-data': !hasData }">
		<div style="width: 100%; height: 100%;">
			<div class="colorBg" class="graph">
				<div class="wrapper">
					<div id="graph-area" #graphArea></div>
				</div>
				<div class="legend-area" *ngIf="!legendDisabled">
					<ul class="legend">
						<li
							class="legend_item primary-color-border"
							[ngClass]="{ item_selected: legendItem.selected, item_unselected: !legendItem.selected }"
							(click)="processSelectedLegendItem(legendItem)"
							*ngFor="let legendItem of legend"
						>
							{{ legendItem.displayName }}
							<i
								*ngIf="legendItem.selected"
								class="fa fa-caret-left"
								[ngStyle]="{ 'font-size': '18px', color: colorPalette.primaryColor }"
							>
							</i>
							<i *ngIf="!legendItem.selected" class="space"></i>
						</li>
					</ul>
				</div>
			</div>
		</div>
		<div class="no-data-container" *ngIf="!hasData">
			<div class="c-portlet o-block u-width-100p _u-width-100p stats-container">
				<div class="o-stack__cell">
					<h5 class="title primary-color">{{ sectiontitle }}</h5>
				</div>
			</div>
			<div class="map-no-data c-portlet">No Data to Display</div>
		</div>
	</div>
</div>
